export const NAME = 'coupons';
export const LEVEL_ONE = 'CouponsComponentReducer';
